import LogoutController from './logout.controller';

const LogoutComponent = {
	controller: LogoutController,
	bindings: {
		$router: '<'
	}
};

export default LogoutComponent;
